import _ from 'lodash';
import { publish } from '@jutro/events';
import { ADOBE_TOPICS, COMMON_TAGGING_PROPERTIES, SgSessionStorageService } from 'saga-modules';

let ACTIVE_TESTS = [];

/**
         * The array of pages for which mvt tests are configured.
         * The content of these pages will be loaded with a delay to
         * allow Adobe to select and apply an offer first.
         */
let MVT_PAGES = ['/vehicle', '/vehiclerev', '/drivers', '/driversrev', '/summaryofdrivers', '/summaryofdriversrev',
    '/premium', '/DECLARATIONS', '/CUE', '/ADDONS', '/CREDITAGGREEMENT', '/BLANKREG', '/payment', '/confirmation', '/retrieve',
    '/retrievalsummary', '/renew', '/renewalsummary', '/error', 'agg', '/Property', '/Details',
    'TailormadeSpecifiedItems', '/Quote', '/Assumptions', '/PropertyRev', '/DetailsRev',
    '/your-details', '/your-property', '/your-cover', '/your-vehicle', '/enhance-your-cover'];

function updateTestArray(testName) {
    if (_.isArray(testName)) {
        ACTIVE_TESTS = testName;
    } else if (!_.isEmpty(ACTIVE_TESTS)) {
        if (!ACTIVE_TESTS.includes(testName)) {
            ACTIVE_TESTS.push(testName);
        }
    } else {
        ACTIVE_TESTS = [testName];
    }
    if (!_.isEmpty(ACTIVE_TESTS)) {
        publish(ADOBE_TOPICS.ADOBE_EVENT, { adobeID: COMMON_TAGGING_PROPERTIES.mvtTests, value: ACTIVE_TESTS });
    }
}
/**
 * Returns the list of active tests
 *
 * @returns {Array}
 */
function getActiveTests() {
    const storedTests = SgSessionStorageService.getItem(SgSessionStorageService.KEY.ACTIVE_TESTS);
    if (!_.isEmpty(storedTests)) {
        updateTestArray(storedTests);
    }
    return ACTIVE_TESTS;
}

/**
 * Stores ACTIVE_TESTS in session storage to be retained on refresh
 */
function storeActiveTests() {
    SgSessionStorageService.setItem(SgSessionStorageService.KEY.ACTIVE_TESTS, ACTIVE_TESTS);
}

function setRefreshFlag(value) {
    SgSessionStorageService.setItem(SgSessionStorageService.KEY.REFRESH_FLAG, value);
}

function getRefreshFlag() {
    return SgSessionStorageService.getItem(SgSessionStorageService.KEY.REFRESH_FLAG);
}

/**
 * Adds a test to the current active tests.
 * @param {String} testName
 */
function addTest(testName) {
    updateTestArray(testName);
    if (getRefreshFlag() !== 'true') {
        // Store the active mvt tests so these are retained for the session
        storeActiveTests();
    }
    publish('updateActiveMvtTests', ACTIVE_TESTS);
}

/**
 * Sets mvt pages.
 * The content displaying is delayed for these pages.
 * The timeout is defined in SgOfferSelectorTimeoutService.
 * @see SgOfferSelectorTimeoutService
 * @param {String} mvtPages
 */
function setMvtPages(mvtPages) {
    if (_.isArray(mvtPages)) {
        MVT_PAGES = MVT_PAGES.concat(mvtPages);
    } else {
        MVT_PAGES.push(mvtPages);
    }
}

function getMvtPages() {
    return MVT_PAGES;
}

function runTest(testName) {
    addTest(testName);
}
// time before all the tests are expected to be loaded (in ms) - it's starting after first test being loaded
const TIMEOUT_FOR_LOADING_TESTS = 500;

function waitForActiveTests() {
    let interval;
    let waitTimeout;
    return new Promise((resolve) => {
        // checks if any test has been added to the array
        let iterations = 0;
        const maxNumberIterations = 20; // equals to 1000ms
        const checkActiveTests = () => {
            // eslint-disable-next-line no-plusplus
            iterations++;
            if (ACTIVE_TESTS.length > 0 || iterations === maxNumberIterations) {
                clearInterval(interval);
                waitTimeout = setTimeout(resolve, iterations !== maxNumberIterations
                    ? TIMEOUT_FOR_LOADING_TESTS : 10);
            }
        };

        // Set up an interval to check for list updates
        interval = setInterval(checkActiveTests, 50);
    }).finally(() => {
        clearTimeout(waitTimeout);
    });
}

export default {
    getActiveTests,
    runTest,
    setRefreshFlag,
    getRefreshFlag,
    storeActiveTests,
    setMvtPages,
    getMvtPages,
    addTest,
    waitForActiveTests
};
